import { RequestHelper } from "../Helpers/RequestHelper.js";

export class PmSalesTaxApi {
    constructor(config) {
        this.config = config;
    }

    getRootURL() {
        return "https://salestax.dev.pixelmotiondemo.com/";
    }

    getURL() {
        return this.getRootURL() + "api";
    }

    getTaxesByZipcode(zipCode, successCallback, errorCallback) {
        RequestHelper.ajax(
            "GET",
            this.getURL() + "/taxes/get/" + zipCode,
            {},
            successCallback,
            errorCallback
        );
    }
}
